import React, { useState, useEffect, useRef} from 'react';
import { useTranslation } from 'react-i18next';
import {Block, Icon, Title} from '../../../components/components';
import {Button, Row} from "react-bootstrap";
import Tabs from '../../../components/Tabs';
import { useHistory, useRouteMatch } from 'react-router';
import { SyncModal } from '../../../components/data_products/streams/SyncModal';
import { SyncStatus } from '../../../components/data_products/streams/SyncStatus'
import Table from "../../../components/tables/Table";
import useCustomTable from "../../../components/tables/useCustomTable";
import TableSearch, {TableSearchRow} from "../../../components/tables/TableSearch";
import Pagination from "../../../components/tables/Pagination";
import { useGetDataProductsQuery, useLazyGetDataProductSyncQuery, useSyncDataProductMutation } from '../../../api/dataProductApiSlice';
import { Loader } from '../../../components/components';
import FilterButton, { FilterGroup } from '../../../components/FilterButton';

function DataProductsList(props) {
  const { t } = useTranslation();
  const [ streams, setStreams ] = useState([]);
  const [ extracts, setExtracts ] = useState([]);
  const [ showModal, setShowModal ] = useState(false);
  const history = useHistory();
  const setEnrichStream = function(data) {
    setStreams(data.map((e) => ({ ...e, check: (<SyncStatus status='pending'/>) })))
  };
  const syncRespToStatus = function(data, stream) {
    if ( data && data.length > 0 ) {
      return Object.assign(stream, {
        check: (<SyncStatus status='ko' errors={data} />)})
    } else {
      return Object.assign(stream, {
        check: (<SyncStatus status='ok'/>)})
    }
  };
  const immutStreamReplace = function(key, callback){
    return streams.map((s)=> {
      if( s.key == key ) {
        return callback(s);
      } else {
        return s
      }
    });
  };
  const [checkSync] = useLazyGetDataProductSyncQuery();
  const runSyncCheck = function() {
    streams.forEach(stream => {
      checkSync(stream.key).then((response)=>{
          setStreams(immutStreamReplace(stream.key, function(s){
            return syncRespToStatus(response.data, s);
          }));
        })
    });
  }
  const isSyncCalled = useRef(false);
  const {data: dataProducts, isSuccess, isLoading} = useGetDataProductsQuery()

  useEffect(() => {
    if (isSuccess) {
      setExtracts(dataProducts.extracts);
      setEnrichStream(dataProducts.streams);
    }
  }, [isSuccess])

  useEffect(()=> {
    if (!isSyncCalled.current && streams.length > 0) {
      isSyncCalled.current = true;
      runSyncCheck();
    }
  }, [streams])

  const streamColumns = [{
    Header: 'Name',
    accessor: 'name'
  },{
    Header: 'Vendor',
    accessor: 'data_vendor.name'
  },{
    Header: 'DataType',
    accessor: 'data_type',
  },{
    Header: 'Environment',
    accessor: 'api_environment'
  },{
    Header: 'Check',
    accessor: 'check',
  }];

  const extractColumns = [{
    Header: 'Name',
    accessor: 'name'
  },{
    Header: 'Vendor',
    accessor: 'data_vendor.name'
  },{
    Header: 'DataType',
    accessor: 'data_type',
  }];

  const tableOptions = {
    sortable: true,
    filterable: true,
    paginate: true
  };

  const showStream = function(data) {
    history.push(`data_vendors/${data.data_vendor.slug}/streams/${data.key}`);
  }

  const showExtract = function(data) {
    history.push(`data_vendors/${data.data_vendor.slug}/extracts/${data.key}`);
  }

  const {
    tableProps: streamTableProps,
    paginationProps: streamPaginationProps,
    tableSearchProps: streamTableSearchProps,
    tableFilterProps: streamTableFilterProps,
  } = useCustomTable(tableOptions)

  const {
    tableProps: extractTableProps,
    paginationProps: extractPaginationProps,
    tableSearchProps: extractTableSearchProps
  } = useCustomTable(tableOptions)

  const [sync] = useSyncDataProductMutation();

  return (
    <>
      <Title main={t("menu.data_products")} group={true} >
        <Button key="col-auto" className="ml-auto" onClick={()=>{setShowModal(true)}}>
          <Icon icon='sync' text={t("sync")} />
        </Button>
      </Title>
      <Tabs>
        <div as="streams" icon="stream">
          <FilterGroup {...streamTableFilterProps}>
            <FilterButton
              title={t("dataVendor.environment")}
              options={["Production", "Preprod"]}
              search={false}
              includeAll={false}
              name="api_environment"/>
            <TableSearch {...streamTableSearchProps} style={{float: "right"}}/>
          </FilterGroup>
          <Block className="mb-0">
            <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
              <Table data={streams} columns={streamColumns} onRowClick={showStream} {...streamTableProps} />
            </Loader>
          </Block>
          <Pagination {...streamPaginationProps}/>
        </div>
        <div as="extracts" icon="csv">
          <TableSearchRow {...extractTableSearchProps}/>
          <Block className="mb-0">
            <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
              <Table data={extracts} columns={extractColumns} onRowClick={showExtract} {...extractTableProps} />
            </Loader>
          </Block>
          <Pagination {...extractPaginationProps}/>
        </div>
      </Tabs>
      <SyncModal show={showModal} setShow={setShowModal} sync={sync} />
    </>
  )
}

export default DataProductsList
